<template>
    <el-row>
        <el-col :span="8">
            <span class="grey fs-3">{{ amountWording }}</span> <br>
            <strong class="fs-4">{{ sharedState.transactionAmount | numberformatCurrencyCustomNumberFormat(this.transactionNumFormat)}}</strong>
        </el-col>
        <el-col :span="8">
            <span class="grey fs-3">{{ $l10n.__('Montant rapproché :') }}</span> <br>
            <strong class="fs-4">{{ reconciledAmount | numberformatCurrencyCustomNumberFormat(this.transactionNumFormat) }}</strong>
        </el-col>
        <el-col :span="8">
            <span class="grey fs-3">{{ $l10n.__('Reste à rapprocher :') }}</span> <br>
            <strong class="fs-4">{{ remainingReconciledAmount | numberformatCurrencyCustomNumberFormat(this.transactionNumFormat) }}</strong>
        </el-col>
    </el-row>
</template>

<script>
import Store from './../../store/reconciliation.js'

export default {
    props : ['transactionType'],
    data() {
        return {
            sharedState: Store.state
        }
    },
    computed: {
        transactionNumFormat(){
            let corpNumberFormat = this.$store.state['corp']['numformat'];
            return  {
                    currency: this.sharedState.transactionCurrencySymbol,
                    currencysymbol: this.sharedState.transactionCurrencySymbol,
                    currencypos: corpNumberFormat.currencypos,
                    decimals: corpNumberFormat.decimals,
                    thousands: corpNumberFormat.thousands,
                    precision: corpNumberFormat.precision
            };
        },
        reconciledAmount: function () {
            const reconciledPaymentAmounts = this.sharedState.reconciled
                .map(reconciled => {
                  let type = reconciled.pay_type;
                  if (type === undefined) {
                    switch (reconciled.document.type) {
                      case 'purInvoice':
                      case 'creditnote':
                        type = 'debit';
                        break;
                      case 'invoice':
                      case 'purCreditNote':
                        type = 'credit';
                        break;
                    }
                  }
                  if (type !== this.transactionType) return reconciled.amount * (-1)
                  else return reconciled.amount
                })
            const transactionRemainingReconciledAmount = reconciledPaymentAmounts.reduce((accumulator, currentValue) => parseFloat(accumulator) + parseFloat(currentValue), 0)
            return parseFloat(this.sharedState.transactionReconciledAmount) + parseFloat(transactionRemainingReconciledAmount)
        },
        remainingReconciledAmount: function () {
            return this.sharedState.transactionAmount - this.reconciledAmount
        },
        amountWording: function () {
            if (this.transactionType == 'credit') {
                return this.$l10n.__('Montant crédité :');
            }
            else if (this.transactionType == 'debit') {
                return this.$l10n.__('Montant débité :');
            }
        }
    }
}
</script>
